import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Create,
  SimpleForm,
  TextInput,
  Edit,
  EditButton,
  Delete,
  Filter,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
  RadioButtonGroupInput,
  required,
  ReferenceField,
  DateField
} from "admin-on-rest/lib/mui";

import { Actions } from "../custom/actions";
import Seasons from "./custom/Seasons";
import RichTextInput from "aor-rich-text-input";
import { RichTextField } from "admin-on-rest";
import { DependentInput } from "aor-dependent-input";

const choices = [
  { id: "Βαθμολογία 1-5", name: "Βαθμολογία 1-5" },
  { id: "πολλαπλής επιλογής ", name: "πολλαπλής επιλογής " }
];

const maxLength = max => value =>
  value && value.length > max ? `Πρεπει να είναι κατω απο  ${max} χαρακτήρες` : undefined;

const validateQuestion = [required, maxLength(250)];
const validateAnswer = [required, maxLength(30)];
// const validateTEST = [maxLength(10)];

const special_bottles = value => values => {
  if (values) {
    console.log("values", values["type"]);
    if (values["type"] == "Βαθμολογία 1-5") {
      return false;
    }
  }
  return true;
};


export const QuestionFilter = props => (
  <Filter {...props}>
    <TextInput label="Ερώτηση" source="title" alwaysOn />
    <ReferenceInput label="Έρευνα" source="survey" reference="survey" alwaysOn>
      <AutocompleteInput optionText={choice => `${choice.title}`} />
    </ReferenceInput>
    <SelectInput
      label="Τύπος"
      source="type"
      choices={[
        { id: "πολλαπλής επιλογής ", name: "πολλαπλής επιλογής " },
        { id: "Βαθμολογία 1-5", name: "Βαθμολογία 1-5" }
      ]}
      alwaysOn
    />
  </Filter>
);

export const QuestionList = props => (
  <List
    {...props}
    actions={<Actions />}
    filters={<QuestionFilter />}
    title="Διαχείριση Ερωτήσεων"
  >
    <Datagrid key={props._id}>
      <RichTextField label="Ερωτηση" source="title" />
      <TextField label="ΑΡΙΘΜΟ ΨΗΦΟΦΟΡΩΝ" source="perce" />
      <ReferenceField
        label="Εταιρεια"
        source="survey.CompanyID"
        reference="companies"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Υποκαταστημα"
        source="survey.BranchID"
        reference="branches"
      >
        <TextField source="address" />
      </ReferenceField>
      <DateField label="ληξη" source="survey.ends_on" />
      <TextField label="τυπος" source="type" />
      <EditButton />
    </Datagrid>
  </List>
);

export const CreateQuestion = props => (
  <Create {...props} title="Δημιουργία Ερώτησης ">
    <SimpleForm redirect="list">
      <RichTextInput source="title" validate={validateQuestion} />
      <ReferenceInput
        label="Quiz Box"
        source="survey"
        reference="survey"
        allowEmpty
      >
        <SelectInput optionText={choice => `${choice.title}`} />
      </ReferenceInput>
      <RadioButtonGroupInput
        source="type"
        choices={choices}
        optionText="name"
        optionValue="id"
      />
      <DependentInput resolve={special_bottles("1")}>
        <Seasons source="seasons">
          <TextInput source="choice" validate={validateAnswer} />
        </Seasons>
      </DependentInput>
    </SimpleForm>
  </Create>
);

const PostTitle = ({ record }) => {
  return <span>{"Έρευνα: " + record.survey.title} <small>(Ο μεγαλύτερος αριθμός χαρακτήρων στην ερώτηση είναι 250)</small></span>;
};

export const EditQuestion = props => (
  <Edit title={<PostTitle />} {...props}>
    <SimpleForm>
      <TextInput label="Κωδικός" source="question_id" />
      <RichTextInput source="title" validate={validateQuestion} />
      <ReferenceInput
        label="Quiz Box"
        source="survey"
        reference="survey"
        allowEmpty
      >
        <SelectInput optionText={choice => `${choice.title}`} />
      </ReferenceInput>
      <RadioButtonGroupInput
        source="type"
        choices={choices}
        optionText="name"
        optionValue="id"
      />
      <DependentInput resolve={special_bottles("1")}>
        <Seasons source="seasons">
          <TextInput source="choice" validate={validateAnswer} />
        </Seasons>
      </DependentInput>
    </SimpleForm>
  </Edit>
);

export const DeleteQuestion = props => <Delete {...props} />;



// WEBPACK FOOTER //
// ./src/pages/questions.js